import { NoddiIcon } from 'noddi-ui-common';
import { RefObject } from 'react';
import { TableCell, TableRow } from '../../../../base/table';

export function TableLoadMoreRow({
  colSpan,
  isLoadingMore,
  sentinelRef,
  loadingMoreText
}: {
  colSpan: number;
  isLoadingMore: boolean;
  sentinelRef: RefObject<HTMLTableRowElement | null>;
  loadingMoreText: string;
}) {
  return (
    <TableRow ref={sentinelRef} className='hover:bg-transparent'>
      <TableCell colSpan={colSpan} className='h-12 text-center'>
        {isLoadingMore && (
          <span className='inline-flex items-center gap-2 text-sm text-muted-foreground'>
            <NoddiIcon name='Loader2' size='small' className='animate-spin' />
            {loadingMoreText}
          </span>
        )}
      </TableCell>
    </TableRow>
  );
}
